import React from 'react';
import { useLocalObservable } from 'mobx-react';
import rootStore from './stores';

const storeContext = React.createContext(null);

export const StoreProvider = ({ children }) => {
    const store = useLocalObservable(() => rootStore);
    return <storeContext.Provider value={store}>{children}</storeContext.Provider>;
}

export const useStore = () => {
    const store = React.useContext(storeContext);
    if (!store) {
        throw new Error('useStore must be used within a StoreProvider.');
    }
    return store;
}